export const environment = {
  production: true,
  envName: 'production',
  apiUrl: 'https://svoms.oddfellow.se/api/',
  cornerRibbonText: 'Produktion',
  cornerRibbonColor: 'blue',
  openIdConnectSettings: {
    authority: 'https://ofmembersprod-openiddict-agapgjbyaghpbaa5.westeurope-01.azurewebsites.net/',
    client_id: 'ofmembersclient-prod',
    redirect_uri: 'https://svoms.oddfellow.se/',
    scope: 'openid profile email roles offline_access ofmembersapi',
    response_type: 'code',
    post_logout_redirect_uri: 'https://svoms.oddfellow.se/',
    automaticSilentRenew: false,
    silent_redirect_uri: 'https://svoms.oddfellow.se/',
    accessTokenExpiringNotificationTime: 10,
    prompt: 'login'
  }
};
